import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import Dashboard from './pages/dashboard/DashboardPage';
import { ToastContainer } from 'react-toastify';
import ProfileTab from './pages/settings/tabs/ProfileTab';
import OrganizationTab from './pages/organization/tabs/OrganizationTab';
import WarehousesTab from './pages/organization/tabs/WarehousesTab';
import SettingsLayout from './pages/settings/SettingsLayout';
import { AuthProvider } from './auth/AuthProvider';
import RequireAuth from './auth/RequireAuth';
import RequireNoAuth from './auth/RequireNoAuth';
import { HomeGate } from './auth/RequireNoAuth';
import LoadsLayout from './pages/organization/loads/LoadsLayout';
import LoadTemplatesTab from './pages/organization/loads/LoadTemplatesTab';
import PalletSizesTab from './pages/organization/loads/PalletSizesTab';
import OrganizationLayout from './pages/organization/OrganizationLayout';
import ResetPasswordTab from './pages/settings/tabs/ResetPasswordTab';
import ProductsLayout from './pages/products/ProductsLayout';
import ProductsListPage from './pages/products/ProductsListPage';
import ProductCreatePage from './pages/products/ProductCreatePage';
import CustomersPage from './pages/customers/CustomersPage';
import CarriersPage from './pages/carriers/CarriersPage';
import InviteLandingPage from './pages/invite/InviteLandingPage';
import CustomerProductsPage from './pages/customer-products/CustomerProductsPage';
import PriceSheetPage from './pages/price-sheet/PriceSheetPage';
import AddressesTab from './pages/settings/tabs/AddressesTab';
import UserOrdersPage from './pages/orders/OrdersPage';
import OrgOrdersPage from './pages/org-orders/OrgOrdersPage';
import LoadMapPage from './pages/load-map/LoadMapPage';
import OrganizationUsersTab from './pages/organization/tabs/OrganizationUsersTab';
import OrgInvitePage from './pages/invite/OrgInvite';
import NotificationPreferencesTab from './pages/settings/tabs/NotificationPreferencesTab';
import CustomerSubusersTab from './components/customer/CustomerSubusersTab';
import CustomerSubuserInvitePage from './components/customer/CustomerSubuserInvitePage';
import OrderNotesDetailPage from './pages/notes/NotesDetals';
import OrderNotesInboxPage from './pages/notes/NotesInbox';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import CustomerTiersPage from './pages/organization/CustomerTiersPage';
import { IntegrationsPage } from './pages/integration/IntegrationsPage';
import { BlumeIntegrationPage } from './pages/integration/BlumeIntegrationPage';
import ApplyPage from './pages/apply/ApplyPage';
import ApplyStatusPage from './pages/apply/StatusPage';
import CustomerApplicationsPage from './pages/customer-applications/CustomerApplicationsPage';
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/invite/:token" element={<InviteLandingPage />} />
          <Route path="/org-invite/:token" element={<OrgInvitePage />} />
          <Route path="/customer-subuser-invite/:token" element={<CustomerSubuserInvitePage />} />
          {/* Public self-service application. Early steps run logged-out; the
              page creates the Firebase account mid-flow and is authed after. */}
          <Route path="/apply" element={<ApplyPage />} />
          <Route element={<RequireNoAuth />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route path="/apply/status" element={<ApplyStatusPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<SettingsLayout />}>
              <Route index element={<Navigate to="profile" replace />} />
              <Route path="profile" element={<ProfileTab />} />
              <Route path="password" element={<ResetPasswordTab />} />
              <Route path="addresses" element={<AddressesTab />} />
              <Route path="notifications" element={<NotificationPreferencesTab />} />
            </Route>
            <Route path="/customer-products" element={<CustomerProductsPage />} />
            <Route path="/customer-orders" element={<UserOrdersPage />} />
            <Route path="/customer-subusers" element={<CustomerSubusersTab />} />
            <Route path="/price-sheet" element={<PriceSheetPage />} />

            {/* ORGANIZATION */}
            <Route path="/organization" element={<OrganizationLayout />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<OrganizationTab />} />
              <Route path="warehouses" element={<WarehousesTab />} />
              <Route path="users" element={<OrganizationUsersTab />} />
              <Route path="loads" element={<LoadsLayout />}>
                <Route index element={<Navigate to="templates" replace />} />
                <Route path="templates" element={<LoadTemplatesTab />} />
                <Route path="pallet-sizes" element={<PalletSizesTab />} />
              </Route>
              <Route path="tiers" element={<CustomerTiersPage />} />
            </Route>
            <Route path="/products" element={<ProductsLayout />}>
              <Route index element={<ProductsListPage />} />
              <Route path="new" element={<ProductCreatePage />} />
              <Route path=":id/edit" element={<ProductCreatePage />} />
            </Route>
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/customer-applications" element={<CustomerApplicationsPage />} />
            <Route path="/carriers" element={<CarriersPage />} />
            <Route path="/orders" element={<OrgOrdersPage />} />
            <Route path="/map" element={<LoadMapPage />} />
            <Route path="/order-notes" element={<OrderNotesInboxPage />} />
            <Route path="/order-notes/:orderId" element={<OrderNotesDetailPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />

            <Route path="/integrations/blume" element={<BlumeIntegrationPage />} />
          </Route>
          <Route path="/" element={<HomeGate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
